import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=978fdeea&scoped=true&"
import script from "./grid.vue?vue&type=script&lang=ts&"
export * from "./grid.vue?vue&type=script&lang=ts&"
import style0 from "./grid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./grid.vue?vue&type=style&index=1&id=978fdeea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978fdeea",
  null
  
)

export default component.exports